module.exports = __webpack_public_path__ + "static/rondaandkyle-7256f477fe3ac5be694b09000eb97f13.jpg";